<style>
#treeviewcuentacontable li {
  font-size: 1rem !important;
  cursor: pointer;
}

#treeviewcuentacontable li span:hover {
  text-decoration: underline;
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Traslados de Polizas</h5>


        <div class="form-desc">
          Traslado de Información de módulos operativos a módulo contable.
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-8">
                <label>
                  Ejercicio
                </label>
                <select v-model="ejercicio" class="form-control bright">
                  <option selected v-for="c_ejercicio in ejercicios" :key="ejercicio.id" :value="c_ejercicio.id">
                    {{ c_ejercicio.id }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      current.errors.fecha_inicio && current.errors.fecha_inicio.length > 0,
                  }">
                    Fecha Inicio
                  </label>
                  <input v-model="current.fecha_inicio" autofocus="autofocus" class="form-control"
                    placeholder="Fecha Inicio" type="date" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_inicio && current.errors.fecha_inicio.length > 0
                    }" />
                  <small v-if="current.errors && current.errors.fecha_inicio" class="form-text text-danger">
                    {{ current.errors.fecha_inicio[0] }}
                  </small>
                </div>
              </div>

              <div class="col-sm-4 col-md-4">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      current.errors.fecha_fin && current.errors.fecha_fin.length > 0,
                  }">
                    Fecha Inicio
                  </label>
                  <input v-model="current.fecha_fin" autofocus="autofocus" class="form-control" placeholder="Fecha Fin"
                    type="date" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_fin && current.errors.fecha_fin.length > 0
                    }" />
                  <small v-if="current.errors && current.errors.fecha_fin" class="form-text text-danger">
                    {{ current.errors.fecha_fin[0] }}
                  </small>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="col-sm-4">

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Módulos</label>
              <div class="col-sm-8">
                <div class="form-check">
                  <label class="form-check-label">
                    <input checked="" class="form-check-input" v-model="current.tipo" type="radio" value="todos">
                    Todos
                  </label>
                </div>

                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="bancos">
                    bancos
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="inv_entrada_compra">
                    inv_entrada_compra
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="ventas">
                    ventas
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="ventas_cobros">
                    ventas_cobros
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="dev_clientes">
                    dev_clientes
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="costos_ventas">
                    costos_ventas
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="costos_dev_clientes">
                    costos_dev_clientes
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="inv_salidas">
                    inv_salidas
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="inv_entradas">
                    inv_entradas
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="cxc_cargos">
                    cxc_cargos
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="cxc_abonos">
                    cxc_abonos
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="cxp_cargos">
                    cxp_cargos
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="cxp_abonos">
                    cxp_abonos
                  </label>
                </div>


                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="current.tipo" type="radio" value="ajustes">
                    ajustes
                  </label>
                </div>

              </div>
            </div>

          </div>


        </div>

        <div class="form-buttons-w">
          <button class="btn btn-primary" type="button" @click="migrarInformacion">Migrar</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import DynamicService from "@/services/commons/DynamicService";

import Notifications from "@/notifications/notifications";

export default {
  components: {
  },
  data() {
    return {
      ejercicio: 2023,
      ejercicios: [],
      current: {
        fecha_inicio: '',
        fecha_fin: '',
        tipo: 'todos',
        errors: {},
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    DynamicService.fetch(
      'conta',
      'ejercicio',
      {
        quitar_paginacion: true
      }
    ).then((response) => {
      self.ejercicios = response.data;
    });
  },
  methods: {
    migrarInformacion() {
      let self = this;
      DynamicService.postAction(
        'conta',
        'ejercicio',
        self.ejercicio,
        'traslada_info',
        self.current
      ).then((response) => {
        Notifications.alert.success(
          "Se ha realizado la migración de los modulos a la contabilidad",
          "Migración a Contabilidad."
        );
      }).catch((error) => {
        Notifications.alert.error(
          "No se ha realizado la migración",
          error.response.data.detail
        );
      });;
    }

  },
};

</script>
